/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Sort_Direction_DescendingInputs */

const en_enum_sort_direction_descending = /** @type {(inputs: Enum_Sort_Direction_DescendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direction Descending`)
};

const de_enum_sort_direction_descending = /** @type {(inputs: Enum_Sort_Direction_DescendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direction Descending`)
};

/**
* | output |
* | --- |
* | "Direction Descending" |
*
* @param {Enum_Sort_Direction_DescendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_sort_direction_descending = /** @type {((inputs?: Enum_Sort_Direction_DescendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Sort_Direction_DescendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_sort_direction_descending(inputs)
	return de_enum_sort_direction_descending(inputs)
});